export const funnelReportsReportIdAppGroupIdDetails = "/funnel_reports/:report_id/:app_group_id/details";
